import Tooltip from '@mui/material/Tooltip';
import Typography, { TypographyOwnProps } from '@mui/material/Typography';
import * as React from 'react';
import { truncateEmail } from '../../helpers/truncateEmail';

export interface IEmailWithTooltipProps extends Omit<TypographyOwnProps, 'noWrap'> {
  component?: React.ElementType;
  email: string;
}

export function EmailWithTooltip({ email, ...typographySettings }: IEmailWithTooltipProps) {
  const truncatedEmail = truncateEmail(email);

  return (
    <Tooltip
      title={truncatedEmail === email ? '' : email}
      slotProps={{ tooltip: { sx: { maxWidth: 'none', whiteSpace: 'nowrap' } } }}
    >
      <Typography noWrap {...typographySettings}>
        {truncatedEmail}
      </Typography>
    </Tooltip>
  );
}

export default EmailWithTooltip;
